export default function FormLabel(theme) {
  return {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          color: theme.palette.error.main,
        },
      },
    },
  };
}
